module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00a_Marsh_fm_prod1"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ct",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00b_Marsh_introduction_prod"
    }
  }, [_vm._v("Introduction: "), _c('i', [_vm._v("Différance")]), _vm._v(". Otherness. Experiment.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/01_Marsh_ch1_prod"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Interrogations of the National Allegory: Trance Film and Ethnography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/02_Marsh_ch2_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Intermediality, Intoxication, and the "), _c('i', [_vm._v("Infrathin")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/03_Marsh_ch3_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Discontinuous Legacies of Pere Portabella: Between Heritage and Inheritance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/04_Marsh_ch4_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space"
  }, [_vm._v("History, Hauntology, Representation: Spanish Cinema against Itself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/05_Marsh_ch5_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The "), _c('i', [_vm._v("Ex")]), _vm._v(" of Experimentation: Against Periodization")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/06_Marsh_ch6_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Catacoustic and the Cosmopolitan: Rhythm and Timbre in the Films of Andrés Duque")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/07_Marsh_ch7_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Turns and Returns, "), _c('i', [_vm._v("Envois")]), _vm._v("/"), _c('i', [_vm._v("Renvois")]), _vm._v(": The Postal Effect in Recent Spanish Film")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/08_Marsh_ch8_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Retrospective Future Perfect: History, Black Holes, and Time Warps in the Films of Los Hijos and Luis López Carrasco")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/09_Marsh_ch9_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "space"
  }, [_c('i', [_vm._v("¡No nos representan!")]), _vm._v(" : Performativity as Militant Film, the 15-M Archive")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ctn",
    attrs: {
      "id": "aft"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/10_Marsh_afterword_prod",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: Unruly Archives. "), _c('i', [_vm._v("La décima carta")]), _vm._v(" and "), _c('i', [_vm._v("Buenas noches, España")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bmht",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/11_Marsh_bibliography_prod",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ctn",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/12_Marsh_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b6a414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 75
// module chunks = 0